import Tabs from "../../components/General/ResponsiveTabs/ResponsiveTabs";
import React, { useState, useEffect } from "react";
import { Box, Tab } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import * as signalR from "@microsoft/signalr";
import "../../assets/styles/pages/Fleet/moneyRequestPage.css";
import useAuth from "../../hooks/useAuth";
import { apiVariable } from "../../api/apiVariable";
import MoneyRequestPopup from "../../components/Fleet/MoneyRequestPopup/MoneyRequestPopup";
import YourRequestsTable from "../../components/Fleet/MoneyRequestsTables/YourRequestsTable";
import NeedingApprovalRequestsTable from "../../components/Fleet/MoneyRequestsTables/NeedingApprovalRequestsTable";
import AllRequestsTable from "../../components/Fleet/MoneyRequestsTables/AllRequestsTable";

const MoneyRequestsPage: React.FC = () => {
  const { token, role } = useAuth();
  const [selectedTab, setSelectedTab] = useState(0);
  const queryClient = useQueryClient();

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${apiVariable}/moneyRequestHub`, {
        accessTokenFactory: () => token || "",
        withCredentials: false,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.None)
      .build();

    connection.on("MoneyRequestUpdated", () => {
      queryClient.invalidateQueries({ queryKey: ["moneyRequests"] });
      queryClient.invalidateQueries({ queryKey: ["needingApprovalRequests"] });
      queryClient.invalidateQueries({ queryKey: ["allRequests"] });
    });

    connection.start();

    return () => {
      connection.stop();
    };
  }, [token, queryClient]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box className="money-requests-page">
      <MoneyRequestPopup />
      <Box sx={{ width: "100%", mt: 1 }}>
        <Tabs value={selectedTab} onChange={handleTabChange} centered>
          <Tab label="Your Requests" />
          {role?.includes("Accounting") && <Tab label="Needing Approval" />}
          {role?.includes("Accounting") && <Tab label="All Requests" />}
        </Tabs>
        {selectedTab === 0 && (
          <Box className="tables-container">
            <YourRequestsTable />
          </Box>
        )}
        {role?.includes("Accounting") && selectedTab === 1 && (
          <Box className="tables-container">
            <NeedingApprovalRequestsTable />
          </Box>
        )}
        {role?.includes("Accounting") && selectedTab === 2 && (
          <Box className="tables-container">
            <AllRequestsTable />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MoneyRequestsPage;
